import type { FaireProductEntity } from "../../entity_types/product";

export const p_kar6xj67pu: FaireProductEntity = {
  token: "p_kar6xj67pu",
  type: "product",
  name: "Basic Essential 100% Wool Beanie, Merino Wool Beanie",
  brandToken: "b_se88gvsk22",
  brandName: "Comfortarians",
  imageUrl:
    "https://cdn.faire.com/fastly/470543248f3aea106533044b0f67efd582dc26b51877073a209eebb2ea739492.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd8f11ac5cf35401ab3b5714132e58d3b8419bee1f7996a33401384f3863b3c5.jpeg",
    "https://cdn.faire.com/fastly/78d82323501463752794a997f7414474c0a006fe5fecc1bfafcf57597c9df603.jpeg",
    "https://cdn.faire.com/fastly/3137d56154015fbb3f31f0bafd1709ff192237ebb993aa422cdbfc321ea73c5c.jpeg",
    "https://cdn.faire.com/fastly/d6eb475c29e21f6653113833d49402a7767e19266a6cac6ffb042fab5212de73.jpeg",
    "https://cdn.faire.com/fastly/10e411bcf0631ee1110e1d37e08e458f679ccf499a693e85386eec75cc50c559.jpeg",
    "https://cdn.faire.com/fastly/62e25fbc9b57d76a77373acee852fb55607033072365453d7dce5238de38429b.jpeg",
    "https://cdn.faire.com/fastly/d0890548675ecdaa2bdfd5410543b12a8d627b2f97d74412491ebd3d0eea33a5.jpeg",
    "https://cdn.faire.com/fastly/81ada1e27cf0b7d7913c2bed72727ccd400a138e50adb0561dbae2c41b2ff6ff.jpeg",
    "https://cdn.faire.com/fastly/161f3cef20f0f37a74e9f2cfaf2823c45ae88f77ab6e993a61c682c5e452d0ac.jpeg",
    "https://cdn.faire.com/fastly/578803eb37b2a8cdd64ee6411af3416a2e97a49db79735393fb48b010e1c62cf.jpeg",
  ],
  priceDollars: 28,
  description:
    "This is Super soft high quality Wool Beanie.\nIt's light but very warm, easy to carry for daily use.\n\n100% Merino Wool",
  tags: [],
  msrpDollars: 50,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:51.120Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
